export default "__VITE_ASSET__BdLXb5PR__"